import { FatInvestorsPageListEntitiesQuery } from '@/__generated__/graphql';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import { useAuth } from '@/hooks/use-auth';
import { TenantType } from '@trace-8/trace8-schema';
import { entityColumns } from '../../constants';
import EntityMobileSumFooter from './entityMobileSumFooter';

interface MobileTableEntityProps {
  listEntity: FatInvestorsPageListEntitiesQuery['listEntities'];
  openInvestorDetailsPage: ({ investorId, entityId, isGroup }: { investorId: string; entityId?: string; isGroup?: boolean }) => Promise<void>;
}

const MobileTableEntity = ({ listEntity, openInvestorDetailsPage }: MobileTableEntityProps) => {
  const { user } = useAuth();

  const TableRow = ({ el }: { el: FatInvestorsPageListEntitiesQuery['listEntities']['data'][number] }) => {
    return (
      <MobileTableRowWrap>
        <MobileRow>
          <MobileRowTitle>{entityColumns[0].title}</MobileRowTitle>
          <MobileRowValue isRedirect onClick={() => openInvestorDetailsPage({ investorId: el.family.id, entityId: el.id, isGroup: el.isGroup })}>
            {el.entityName}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{entityColumns[1].title}</MobileRowTitle>
          <MobileRowValue isRedirect onClick={() => openInvestorDetailsPage({ investorId: el.family.id })}>
            {el.family.name}
          </MobileRowValue>
        </MobileRow>

        {user && user.tenant.type === TenantType.PLATFORM_MANAGER && (
          <MobileRow>
            <MobileRowTitle>{entityColumns[2].title}</MobileRowTitle>
            <MobileRowValue>{el.tenant.name}</MobileRowValue>
          </MobileRow>
        )}

        <MobileRow>
          <MobileRowTitle>{entityColumns[3].title}</MobileRowTitle>
          <MobileRowValue>{el.investmentCount}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{entityColumns[4].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip>{el.totalEntityValue}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{entityColumns[5].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip>{el.totalCommitments}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {listEntity.data.length ? (
        <>
          {listEntity.data.map((el) => (
            <TableRow el={el} key={el.id} />
          ))}
          <EntityMobileSumFooter columns={entityColumns} totals={listEntity.totals} />
        </>
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTableEntity;
